import { Component, signal } from '@angular/core';
import { AppScope, currentAppScope } from '../../core/scope/app-scope';
import { OrganizationTaskDetailComponent } from './organization-task-detail.component';
import { WorkflowTaskDetailComponent } from './workflow-task-detail.component';

@Component({
  standalone: true,
  selector: 'ain-workflow-task-detail-entry',
  imports: [WorkflowTaskDetailComponent, OrganizationTaskDetailComponent],
  template: `
    @if (isOrganizationScope()) {
      <ain-organization-task-detail />
    } @else {
      <ain-workflow-task-detail />
    }
  `
})
export class WorkflowTaskDetailEntryComponent {
  readonly appScope = signal<AppScope>(currentAppScope());

  isOrganizationScope(): boolean {
    return this.appScope() === 'organization';
  }
}

